module.exports = __webpack_public_path__ + "static/media/Janet Tingey.f15475b0.png";